import React from 'react';
import { motion } from 'framer-motion';
export function PainPointsSection() {
  const painPoints = ['el niño se frustra', 'se bloquea', 'pierde interés', 'y no ves avances reales'];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-107">
      <div className="max-w-4xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-12" data-id="element-109">
          <h2 className="text-3xl md:text-4xl font-black text-[#111111] mb-4 leading-tight" data-id="element-110">
            Querés ayudar… pero no sabés cómo enseñarle a leer sin frustrarlo
          </h2>

          <div className="w-16 h-1 bg-[#C4A7E7] rounded-full mb-10" data-id="element-111"></div>

          <div className="space-y-6" data-id="element-112">
            <p className="text-lg md:text-xl text-[#111111] leading-relaxed" data-id="element-113">
              Si trabajás con niños con autismo o discapacidad intelectual…
            </p>

            <p className="text-xl md:text-2xl font-bold text-[#C4A7E7]" data-id="element-114">
              sabés que los métodos tradicionales no funcionan.
            </p>

            <p className="text-lg md:text-xl text-[#111111] leading-relaxed" data-id="element-115">
              Intentás ayudar, buscás actividades, probás distintas formas…
              <br data-id="element-116" />
              pero muchas veces pasa lo mismo:
            </p>

            <div className="bg-white border-l-4 border-red-400 rounded-r-2xl p-6 md:p-8 space-y-3" data-id="element-117">
              {painPoints.map((point, idx) => <p key={idx} className="text-lg md:text-xl text-[#111111] font-medium flex items-center gap-3" data-id="element-118">
                  <span className="text-red-500 text-xl" data-id="element-119">❌</span>
                  {point}
                </p>)}
            </div>

            <p className="text-lg md:text-xl text-[#111111] leading-relaxed" data-id="element-120">
              Encima, cada lugar trabaja diferente: en la escuela usan un
              método, en terapia otro, y en casa improvisás con lo que encontrás
              en internet.
            </p>

            <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 space-y-4" data-id="element-121">
              <p className="text-lg md:text-xl font-bold text-[#111111]" data-id="element-122">
                El resultado es un cortocircuito:
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-123">
                El niño recibe tres códigos distintos al mismo tiempo. Un
                pictograma en el aula, otro en el consultorio, ninguno en casa.
                No es que no pueda aprender — es que nadie le dio un sistema
                consistente.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-124">
                Descargás fichas de Pinterest que no están pensadas para cómo
                procesa la información un niño con autismo. Tienen demasiadas
                imágenes, demasiado texto, demasiado ruido visual. Y cuando no
                funcionan, sentís que el problema sos vos.
              </p>
              <p className="text-base md:text-lg text-gray-700 leading-relaxed" data-id="element-125">
                Sabés que algo avanza, pero no podés demostrarlo. La maestra
                pregunta, el terapeuta pregunta, y vos tenés todo en la cabeza
                pero nada en el papel. Sin registro, sin estructura, sin
                evidencia.
              </p>
            </div>

            <p className="text-lg md:text-xl text-[#111111] font-medium mt-4" data-id="element-126">
              Y lo peor…
            </p>

            <div className="bg-[#C4A7E7]/10 border border-[#C4A7E7]/30 rounded-2xl p-6 md:p-8" data-id="element-127">
              <p className="text-xl md:text-2xl text-[#111111] font-bold leading-relaxed" data-id="element-128">
                👉 terminás sintiendo que podés estar haciéndolo mal.
              </p>
              <p className="text-base md:text-lg text-gray-600 mt-3 leading-relaxed" data-id="element-129">
                Que quizás estás perdiendo un tiempo valioso. Que cada semana
                que pasa sin un método claro es una semana donde el niño podría
                haber avanzado… y no lo hizo.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-[#C4A7E7] text-white p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-130">
          <p className="text-2xl md:text-3xl font-medium leading-relaxed" data-id="element-131">
            No es falta de voluntad. No es falta de amor.{' '}
            <strong className="font-black text-white block mt-2" data-id="element-132">
              Es falta de un sistema que realmente funcione para él.
            </strong>
          </p>
        </motion.div>
      </div>
    </section>;
}